import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/logos/steam.png")